import * as React from "react";
import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  InputGroup,
  InputLeftElement,
  Text,
} from '@chakra-ui/react';
import {
  MdPhone,
  MdOutlineEmail,
} from 'react-icons/md';
import { BsPerson } from 'react-icons/bs';

export const ContactFormForm = ({handleSubmit}) => {
  return (
    <form style={{width: '100%'}} onSubmit={handleSubmit}>
      <FormControl id="name" pb={2} isRequired={true}>
        <FormLabel>Name</FormLabel>
        <InputGroup borderColor="#E0E1E7">
          <InputLeftElement
            pointerEvents="none"
            children={<BsPerson color="gray.800" />}
          />
          <Input type="name" size="md" name="NAME"/>
        </InputGroup>
      </FormControl>
      <FormControl id="email" pb={2} isRequired={true}>
        <FormLabel>Email Address</FormLabel>
        <InputGroup borderColor="#E0E1E7">
          <InputLeftElement
            pointerEvents="none"
            children={<MdOutlineEmail color="gray.800" />}
          />
          <Input type="email" size="md" name="EMAIL"/>
        </InputGroup>
      </FormControl>
      <FormControl id="phone" pb={2} isRequired={true}>
        <FormLabel>Phone</FormLabel>
        <InputGroup borderColor="#E0E1E7">
          <InputLeftElement
            pointerEvents="none"
            children={<MdPhone color="gray.800" />}
          />
          <Input type="phone" size="md" name="PHONE" />
        </InputGroup>
      </FormControl>
      <FormControl id="message" pb={2} isRequired={true}>
        <FormLabel>Message</FormLabel>
        <Textarea
          borderColor="gray.300"
          fontSize="16px"
          _hover={{
            borderRadius: 'gray.300',
          }}
          placeholder="Type your message here and include a summary of what you are looking for."
          size="sm"
          height={200}
          name="MESSAGE"
        />
      </FormControl>
      <FormControl float="right">
        <Text style={{fontSize: '11px'}} mb={2}>
          This site is protected by reCAPTCHA and the Google <a target='_blank' rel='noopener noreferrer nofollow' href="https://policies.google.com/privacy"> Privacy Policy</a> and <a target='_blank' rel='noopener noreferrer nofollow' href="https://policies.google.com/terms"> Terms of Service</a> apply.
        </Text>
        <Button
          type="submit"
          id='submit'
          fontFamily={'PoppinsMedium, sans-serif, serif'}
          fontWeight={'normal'}
          bg={'#7B4B94'}
          color={'white'}
          _hover={{
            bg: '#582e6e',
          }}
          width={'100%'}>
          Send Message
        </Button>
      </FormControl>
    </form>
  );
};
